export default __webpack_public_path__ + "static/media/Factory06.d87fad5d.jpg";